'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefix = require('../prefix');

var _prefix2 = _interopRequireDefault(_prefix);

var _pascalize = require('../utils/pascalize');

var _pascalize2 = _interopRequireDefault(_pascalize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// clip-path has basic support in webkit without prefix for svg documents
// but in other cases it might need a prefix. We can resort to value testing.
// See https://developer.mozilla.org/de/docs/Web/CSS/clip-path
exports['default'] = {
  noPrefill: ['clip-path'],
  supportedProperty: function supportedProperty(prop, style) {
    if (prop === 'clip-path' && _prefix2['default'].js === 'Webkit') {
      style.clipPath = 'inset(10px 20px 30px 40px)';
      var value = style.clipPath;
      style.clipPath = '';
      if (value) return prop;
      if (_prefix2['default'].js + (0, _pascalize2['default'])(prop) in style) {
        return _prefix2['default'].css + prop;
      }
    }
    return false;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-vendor/lib/plugins/clip-path.js
// module id = 654
// module chunks = 0